export default{
	domain:"www.huiliangtianxia.cn",
	full_name:"广州汇量天下网络科技有限公司",
	short_name:"广州汇量天下",
	platform_name:"汇量天下互动",
	address:"广州市天河区华旭街1号1633房",
	tel:"1894308178",
	fax:"1894308178",
	qq:"1619828831",
	email:"hltx@huiliangtianxia.cn",
	zip_code:"510000",
	web_icp:"粤ICP备2020118374号-1",
	main_icp:"粤ICP备2020118374号",
	ncol:"粤网文[2016]7021-1672号"//文网文
}


// WEBPACK FOOTER //
// ./src/config.js